import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
// import Section10CImg from "./Section10C.png";
import Section10CImg from "./Section10C.png";
import { TbCircleNumber4Filled } from "react-icons/tb";

const Section10E = ({ data, index }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: { xs: "40px", sm: "0px" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          // width: { xl: "72%", lg: "80%", md: "95%", sm: "94%" },
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          justifyContent: { xl: "space-between", lg: "space-between" },
          // border: "1px solid blue",
          // px: { xs: 2, md: 5 },
          py: { xs: 0, sm: 4 },
          border: { xs: "1px solid #ddd", sm: "none" },
          borderTopLeftRadius: { xs: "16px", sm: "0px" },
          borderTopRightRadius: { xs: "16px", sm: "0px" },
        }}
      >
        {/* Image Section */}
        <Box
          component="img"
          // src={Section10CImg}
          src={data[index]?.use_case[3]?.img || Section10CImg}
          alt="Section 10B"
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            marginBottom: { xs: "40px", sm: "0px" },
            display: { xs: "none", sm: "flex" },
          }}
        />

        <Box
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            display: { xs: "flex", sm: "none" },
            marginBottom: { xs: "28px", sm: "0px" },
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            overflow: "hidden",
            position: "relative",

            // Glassmorphism effect
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid #ddd",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",

            // Shimmer effect
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: "-150%",
              height: "100%",
              width: "150%",
              background:
                "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
              animation: "shineEffect 2s infinite",
            },
            "@keyframes shineEffect": {
              "0%": { left: "-150%" },
              "50%": { left: "100%" },
              "100%": { left: "150%" },
            },
          }}
        >
          <Box
            component="img"
            // src={Section10CImg}
            src={data[index]?.use_case[3]?.img || Section10CImg}
            alt="Section 10B"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        </Box>

        {/* desktop Text Content */}
        <Box
          sx={{
            maxWidth: { xs: "100%", md: "600px" },
            marginBottom: { xs: "0px", md: "0" },
            display: { xs: "flex", sm: "flex" },
            // border: "1px solid red",
            flexDirection: "column",
          }}
        >
          <Stack
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              paddingLeft: "32px", // optional padding
              marginBottom: "16px",
            }}
          >
            {/* #1 background label */}
            <Typography
              sx={{
                position: "absolute",
                top: {
                  xl: "-72px",
                  lg: "-72px",
                  md: "-62px",
                  sm: "-44px",
                  xs: "-36px",
                },
                left: {
                  xl: "-40px",
                  lg: "-40px",
                  md: "-32px",
                  sm: "0px",
                  xs: "0px",
                },
                fontSize: {
                  xl: "100px",
                  lg: "100px",
                  md: "80px",
                  sm: "60px",
                  xs: "50px",
                },
                color: "#e0e0e0", // light gray
                fontWeight: 700,
                zIndex: 1,
                userSelect: "none",
              }}
            >
              #4
            </Typography>

            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                zIndex: 2,
                position: "relative",
                fontWeight: 700,
                lineHeight: {
                  lg: "32px",
                  xl: "32px",
                  md: "32px",
                  xs: "24px",
                  sm: "24px",
                },
                fontSize: {
                  lg: "28px",
                  xl: "28px",
                  md: "28px",
                  xs: "20px",
                  sm: "20px",
                },
                fontFamily: "'Roboto', sans-serif",
                color: "rgb(0, 0, 0)",
              }}
            >
              {/* Run Ads that Click to WhatsApp */}
              {data[index]?.use_case[3]?.title || "title"}
            </Typography>
          </Stack>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: { xs: "0px", sm: "12px" },
              paddingLeft: { xs: "12px", sm: "12px" },
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* Capture Leads & collect useful information Directly in WhatsApp
            Chats with WhatsApp Forms. */}
            {data[index]?.use_case[3]?.description1 || "description1"}
            {/* {ComponentData[index]?.section10B?.card_head2} */}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "32px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: { xs: "0px", sm: "12px" },
              paddingLeft: { xs: "12px", sm: "12px" },
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* From feedback to gathering user insights, collect it all on
            WhatsApp. */}
            {data[index]?.use_case[3]?.description2 || "description2"}
            {/* {ComponentData[index]?.section10B?.card_head3} */}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

export default Section10E;
